<template>
  <div
    v-bind:style="showModalSubjects ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Motivo de anulación :: #{{rq.id}}</h5>
          <button
            @click="close"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <b-row>
            <b-col lg="12">
              <b-form @submit.prevent="send()">
                <b-row class="form-group">
                  <label class="col-sm-12 col-form-label">Indique motivo</label>
                  <div class="col-sm-12">
                    <textarea cols="5" rows="10" v-model="subjects" class="form-control" />
                  </div>
                </b-row>
                <b-row class="form-group">
                  <div class="col-sm-12">
                    <input type="submit" class="btn btn-success" value="Enviar" />
                  </div>
                </b-row>
              </b-form>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalSubjects",
  props: ['rq', 'showModalSubjects'],
  data(){
    return {
      subjects: null
    }
  },
  methods: {
    close() {
      this.subjects = ''
      this.$emit("close");
    },
    send(){
      if(this.subjects){
        this.$emit('sendSubjects', this.subjects)
        this.subjects = ''
      } else {
        this.$toastr.error('Debes ingresar un motivo', "Éxito", {
          positionClass: "toast-top-center",
          closeButton: true
        });
      }
    }
  },
};
</script>